import {
  FilterMode,
  TenantWidgetAccessCreateMutationVariables,
  TenantWidgetAccess_OrderBy,
  TenantWidgetAccess,
  SortOrder,
  TenantWidgetAccess_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const tenantWidgetAccessService = {
  createOne: buildCreateOne(
    (
        tenantWidgetAccessCreateVariables: TenantWidgetAccessCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.tenantWidgetAccessCreate(
          tenantWidgetAccessCreateVariables
        );
        return result.tenantWidgetAccessCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.tenantWidgetAccessOne({ id });
    return result.tenantWidgetAccessOne as TenantWidgetAccess;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: TenantWidgetAccess_OrderBy[] | null = null,
    filter: TenantWidgetAccess_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: TenantWidgetAccess_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.tenantWidgetAccessListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.tenantWidgetAccessListWithOffset
    ) as TenantWidgetAccess[];
    return { list, orderBy };
  },
};
